import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './Callback.module.css';
import { useCallback } from './Callback.hooks';

import { Loading } from '../../../components/loading/Loading';

export const Callback = () => {
	const navigate = useNavigate();
	const { isLoading, error, isSubscribed } = useCallback();
	useEffect(() => {
		if (isSubscribed) {
			navigate('/', { replace: true });
			location.reload();
		}
	}, [isSubscribed]);
	if (error) {
		return <div className={styles['error']}>{error.message}</div>;
	}
	if (isLoading) {
		return (
			<div className={styles['loading']}>
				<Loading />
			</div>
		);
	}

	if (!isSubscribed) {
		return <SubscriptionRequired />;
	}
	return <div>Callback</div>;
};

function SubscriptionRequired() {
	return (
		<div className={styles['subscription-required']}>
			<section>
				<h1>Login Successful</h1>
				<h2>A valid subscription is required to access this content</h2>

				<Link to={'/subscriptions'}>Purchase Subscription</Link>
				<p>
					Or <Link to={'/'}>Return to Magazine</Link>
				</p>
			</section>
		</div>
	);
}
